import { app } from '../../../../app';
import { Controller } from './user-directories.controller';

app.component('companyUserDirectoriesDirectoryGroups', {
    bindings: {
        directoriesDto: '<'
    },
    controller: Controller,
    templateUrl: require('./user-directories.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/user-directories.component.js